module.exports = __webpack_public_path__ + "static/media/auth_background.c498812f.svg";